import React from "react";
// eslint-disable-next-line import/named
import MuiBox, { BoxProps as MuiBoxProps } from "@mui/material/Box";

export interface BoxProps extends Omit<MuiBoxProps, "border" | "sx"> {
  componentName: string;
  border?: boolean;
  sx?: Record<string, any>;
}

export const Box = ({
  border = true,
  componentName,
  sx,
  ...props
}: BoxProps) => {
  // this checks for the label of a textfield so that the border
  // is not applied (border strikesthrough the label)
  const hasLabel = React.Children.toArray(props.children).some(
    (child: any) => child?.props?.label,
  );

  return (
    <MuiBox
      {...props}
      data-testid={`${componentName}-Box`}
      sx={{
        boxSizing: "border-box",
        border: border && !hasLabel ? "1px solid" : "none",
        borderColor: "primary.main",
        borderRadius: "2px",
        flexGrow: 1,
        ...sx,
      }}
    />
  );
};
